import React, { createContext, Dispatch, SetStateAction, useState } from 'react';
import { Auth } from 'Shared/auth';
import LoadingIndicator from 'Shared/loading_indicator';
import ApiRequest from 'Shared/api_2_0';

const noop = () => {};

const defaultContext = {
   isSubscribed: false,
   subscribe: noop as (_guideid: number, _langid: string) => void,
   unsubscribe: noop as (_guideid: number, _langid: string) => void,
};

const GuideSubscriptionContext = createContext(defaultContext);

function withGuideSubscription<T>(Component: React.ComponentType<T>) {
   return function GuideSubscriptionProvider(props: { isSubscribed?: boolean } & T) {
      const [isSubscribed, setSubscribed] = useState(
         props.isSubscribed || defaultContext.isSubscribed
      );

      const guideSubscriptionContext = {
         subscribe: (guideid: number, langid: string) => {
            doSubscriptionGuide(guideid, langid, true, setSubscribed);
         },
         unsubscribe: (guideid: number, langid: string) => {
            doSubscriptionGuide(guideid, langid, false, setSubscribed);
         },
         isSubscribed,
      };

      return (
         <GuideSubscriptionContext.Provider value={guideSubscriptionContext}>
            <Component {...props} />
         </GuideSubscriptionContext.Provider>
      );
   };
}

function doSubscriptionGuide(
   guideid: number,
   langid: string,
   wantsToSubscribe: boolean,
   setSubscribed: Dispatch<SetStateAction<boolean>>
) {
   Auth.required({
      from: '',
      message: _js('Log in to subscribe.'),
      onAuthorize: LoadingIndicator.withEventHandler(
         () => {
            const guide = window.guide_constants.DocumentWatch('DOCTYPE_GUIDE');
            const edit = window.guide_constants.DocumentWatch('LEVEL_EDIT');
            const url = `subscribe/${guide}/${guideid}/${langid}/${edit}`;
            const method = wantsToSubscribe ? 'put' : 'delete';
            const request = new ApiRequest(url, { method });
            return request.send().then(() => {
               setSubscribed(wantsToSubscribe);
            });
         },
         {
            pendingMessage: wantsToSubscribe
               ? _js('Adding Subscription')
               : _js('Removing Subscription'),
            successMessage: wantsToSubscribe
               ? _js('Added Subscription')
               : _js('Removed Subscription'),
            failureMessage: _js('Failure'),
         }
      ),
   });
}

export { GuideSubscriptionContext, withGuideSubscription };
